// class PredictiveSearch extends HTMLFormElement {
//   constructor() {
//     super();
//     this.cachedMap = new Map();
//     this.focusElement = this.input;
//     this.resetButton.addEventListener('click', this.clear.bind(this));
//     this.input.addEventListener('input', FoxTheme.utils.debounce(this.onChange.bind(this), 300));
//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.searchContent = this.querySelector('.search__content');
//     this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';

//     const isTemplateSearch = this.closest('.template-search');
//     if (isTemplateSearch) {
//       document.addEventListener('click', this.handleClickOutside.bind(this));
//     }
//   }

//   get input() {
//     return this.querySelector('input[type="search"]');
//   }
//   get resetButton() {
//     return this.querySelector('button[type="reset"]');
//   }

//   onFocus(event) {
//     if (this.closest('.template-search')) {
//       document.body.classList.add('predictive-search-open');
//       if (this.getQuery().length === 0) {
//         return;
//       }
//       const url = this.setupURL().toString();
//       this.renderSection(url, event);
//     }
//   }
//   getQuery() {
//     return this.input.value.trim();
//   }
//   clear(event = null) {
//     event && event.preventDefault();
//     if (this.searchRecommendationEmpty && this.searchContent) {
//       this.searchContent.classList.add('hidden');
//     }
//     this.input.value = '';
//     this.input.focus();
//     this.removeAttribute('results');
//   }

//   setupURL() {
//     const url = new URL(`${FoxTheme.routes.shop_url}${FoxTheme.routes.predictive_search_url}`);
//     return (
//       url.searchParams.set('q', this.getQuery()),
//       url.searchParams.set('resources[limit]', this.dataset.resultsLimit || 3),
//       url.searchParams.set('resources[limit_scope]', 'each'),
//       url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this)),
//       url
//     );
//   }

//   onChange() {
//     if (this.getQuery().length === 0) {
//       this.clear();
//       return;
//     }
//     const url = this.setupURL().toString();
//     this.renderSection(url);
//   }

//   renderSection(url) {
//     this.cachedMap.has(url) ? this.renderSectionFromCache(url) : this.renderSectionFromFetch(url);
//   }

//   renderSectionFromCache(url) {
//     const responseText = this.cachedMap.get(url);
//     this.renderSearchResults(responseText), this.setAttribute('results', '');
//   }

//   renderSectionFromFetch(url) {
//     // Indicate that loading has started
//     this.setAttribute('loading', 'true');
//     this.resetButton.classList.add('btn--loading');

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.text();
//       })
//       .then((responseText) => {
//         // Process and cache the fetched data
//         this.renderSearchResults(responseText);
//         this.cachedMap.set(url, responseText);
//       })
//       .catch((error) => {
//         console.error('Error fetching data: ', error);
//         this.setAttribute('error', 'Failed to load data');
//       })
//       .finally(() => {
//         // Remove the loading attribute in both success and error cases
//         this.removeAttribute('loading');
//         this.resetButton.classList.remove('btn--loading');
//         this.setAttribute('results', 'true');
//       });
//   }
//   renderSearchResults(responseText) {
//     const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
//     const targetElement = document.getElementById(id);

//     if (targetElement) {
//       const parser = new DOMParser();
//       const parsedDoc = parser.parseFromString(responseText, 'text/html');
//       const contentElement = parsedDoc.getElementById(id);

//       if (contentElement) {
//         this.searchContent?.classList.remove('hidden');
//         targetElement.innerHTML = contentElement.innerHTML;
//       } else {
//         console.error(`Element with id '${id}' not found in the parsed response.`);
//       }
//     } else {
//       console.error(`Element with id '${id}' not found in the document.`);
//     }
//   }

//   handleClickOutside(event) {
//     if (!this.contains(event.target)) {
//       setTimeout(() => {
//         document.body.classList.remove('predictive-search-open');
//       });
//     }
//   }
// }
// customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });

// class SearchDrawer extends DrawerComponent {
//   constructor() {
//     super();
//   }
//   get requiresBodyAppended() {
//     return false;
//   }
//   get input() {
//     return this.querySelector('input[type="search"]');
//   }
//   get focusElement() {
//     return this.querySelector('input[type="search"]');
//   }
// }
// customElements.define('search-drawer', SearchDrawer);



(() => {
  const storedQueryPattern = /^title:[\p{L}\p{N}]+(?: AND title:[\p{L}\p{N}]+)*\*?$/u;
  const displayQuery = (value) => {
    const query = String(value || '').trim();
    return storedQueryPattern.test(query) ? query.replace(/title:/g, '').replace(/ AND /g, ' ').replace(/\*$/, '') : query;
  };
  const buildQuery = (value) => {
    const words = String(value || '').match(/[\p{L}\p{N}]+/gu) || [];
    return words.map((word, index) => `title:${word}${index === words.length - 1 ? '*' : ''}`).join(' AND ');
  };
  const buildURL = (action, value) => {
    const url = new URL(action, window.location.origin);
    url.search = '';
    url.searchParams.set('q', buildQuery(value));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url;
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.search__form')) return;
    const input = form.querySelector('input[type="search"]');
    if (!input) return;
    event.preventDefault();
    if (!buildQuery(input.value)) return;
    window.location.assign(buildURL(form.action, input.value).toString());
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-search-query]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.location.assign(buildURL(link.href, link.dataset.searchQuery).toString());
  });

  const initializeSearchPage = () => {
    const page = document.querySelector('[data-suncasa-search-page]');
    if (!page) return;
    const value = displayQuery(page.dataset.searchTerms);
    const query = buildQuery(value);
    const url = new URL(window.location.href);
    if (query && (url.searchParams.get('q') !== query || url.searchParams.get('type') !== 'product' || url.searchParams.get('options[prefix]') !== 'last')) {
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      window.location.replace(url.toString());
      return;
    }
    page.hidden = false;
  };

  class PredictiveSearch extends HTMLFormElement {
    constructor() {
      super();
      this.cachedMap = new Map();
      this.requestId = 0;
      this.focusElement = this.input;
      this.searchContent = this.querySelector('.search__content');
      this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
      this.resetButton?.addEventListener('click', this.clear.bind(this));
      this.input.addEventListener('input', () => {
        this.cancelRequest();
        this.removeAttribute('results');
        this.removeAttribute('error');
        this.setExpanded(false);
        if (this.searchContent) this.searchContent.classList.add('hidden');
        if (!buildQuery(this.getQuery())) {
          this.showRecommendations();
          return;
        }
        this.debounceTimer = setTimeout(() => this.onChange(), 300);
      });
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.outsideClick = this.handleClickOutside.bind(this);
    }

    connectedCallback() {
      if (this.closest('.template-search')) document.addEventListener('click', this.outsideClick);
    }

    disconnectedCallback() {
      this.cancelRequest();
      document.removeEventListener('click', this.outsideClick);
    }

    get input() {
      return this.querySelector('input[type="search"]');
    }

    get resetButton() {
      return this.querySelector('button[type="reset"]');
    }

    getQuery() {
      return this.input.value.trim();
    }

    setExpanded(expanded) {
      this.input.setAttribute('aria-expanded', String(expanded));
    }

    onFocus() {
      if (this.closest('.template-search')) document.body.classList.add('predictive-search-open');
      if (buildQuery(this.getQuery())) this.onChange();
    }

    cancelRequest() {
      clearTimeout(this.debounceTimer);
      this.requestId += 1;
      this.abortController?.abort();
      this.removeAttribute('loading');
      this.resetButton?.classList.remove('btn--loading');
    }

    showRecommendations() {
      this.removeAttribute('results');
      this.removeAttribute('error');
      this.setExpanded(false);
      this.searchContent?.classList.toggle('hidden', this.searchRecommendationEmpty);
    }

    clear(event = null) {
      event?.preventDefault();
      this.cancelRequest();
      this.input.value = '';
      this.showRecommendations();
      this.input.focus();
    }

    setupURL() {
      const url = buildURL(this.action, this.getQuery());
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
      return url;
    }

    onChange() {
      if (!buildQuery(this.getQuery())) {
        this.cancelRequest();
        this.showRecommendations();
        return;
      }
      this.renderSection(this.setupURL().toString());
    }

    async renderSection(url) {
      this.cancelRequest();
      const requestId = this.requestId;
      const query = this.getQuery();
      const isCurrent = () => requestId === this.requestId && query === this.getQuery();
      this.removeAttribute('error');
      this.removeAttribute('results');
      this.setExpanded(false);
      this.searchContent?.classList.add('hidden');
      this.setAttribute('loading', 'true');
      this.resetButton?.classList.add('btn--loading');
      this.abortController = new AbortController();

      try {
        let responseText = this.cachedMap.get(url);
        if (responseText === undefined) {
          const response = await fetch(url, { signal: this.abortController.signal });
          if (!response.ok) throw new Error('Search request failed');
          responseText = await response.text();
          if (!isCurrent()) return;
          if (this.cachedMap.size >= 30) this.cachedMap.delete(this.cachedMap.keys().next().value);
          this.cachedMap.set(url, responseText);
        }
        if (!isCurrent()) return;
        if (!this.renderSearchResults(responseText)) throw new Error('Search results were not returned');
        this.setAttribute('results', 'true');
        this.setExpanded(true);
      } catch (error) {
        if (error.name === 'AbortError' || !isCurrent()) return;
        this.setAttribute('error', 'true');
        const target = this.querySelector('[data-search-results]');
        const fallback = this.querySelector('template[data-search-fallback]');
        if (target && fallback) {
          target.replaceChildren(fallback.content.cloneNode(true));
          this.searchContent?.classList.remove('hidden');
          this.setAttribute('results', 'true');
          this.setExpanded(true);
        }
      } finally {
        if (isCurrent()) {
          this.removeAttribute('loading');
          this.resetButton?.classList.remove('btn--loading');
        }
      }
    }

    renderSearchResults(responseText) {
      const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);
      const target = this.querySelector('[data-search-results]');
      const parsed = new DOMParser().parseFromString(responseText, 'text/html');
      const content = parsed.getElementById(id);
      if (!target || !content) return false;
      target.innerHTML = content.innerHTML;
      this.searchContent?.classList.remove('hidden');
      return true;
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        document.body.classList.remove('predictive-search-open');
        this.setExpanded(false);
      }
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch, { extends: 'form' });
  }

  class SearchDrawer extends DrawerComponent {
    get requiresBodyAppended() {
      return false;
    }
    get input() {
      return this.querySelector('input[type="search"]');
    }
    get focusElement() {
      return this.querySelector('input[type="search"]');
    }
  }
  if (!customElements.get('search-drawer')) customElements.define('search-drawer', SearchDrawer);
  initializeSearchPage();
})();